import type { ToastType } from '@nuvolo/nuux-core/components/NuvoToast';
import { createContext } from 'react';

export interface AskButton<R> {
  key: string;
  label: string;
  value: R;
}

export interface ToastContextType {
  alert: (type: ToastType, message: string) => Promise<void>;
  confirm: (
    type: ToastType,
    message: string,
    yesNoTxt?: [string, string],
  ) => Promise<boolean>;
  ask: <R>(
    type: ToastType,
    message: string,
    btns: AskButton<R>[],
  ) => Promise<R>;
}

const ToastContext = createContext<ToastContextType>({} as ToastContextType);

export default ToastContext;
